import { render } from "./ThanksRegister.vue?vue&type=template&id=325cd3ca"
import script from "./ThanksRegister.vue?vue&type=script&lang=js"
export * from "./ThanksRegister.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__